<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  > 
  
    <!----------PROJECT TABLE-------------------->
    <div v-for="(proj,id) in projectResult" :key="proj.id" v-if="category === 'Project' ">
      <material-card
        icon="mdi-folder"
        icon-small
        :title="new Date(proj[0].project_start_date).getFullYear().toString()"
        color="accent"
        :subtitle="$t('Project')"
      >
        <v-data-table
          :headers="projectHeaders"
          :items="proj" 
        >
          <template v-for="header in projectHeaders" v-slot:[`header.${header.value}`]="{ header }">
            <span>{{ getHeader(header.text) }}</span>
          </template>
          <template v-slot:item.name="{ item }">
            <div>{{ getTranslation(item.project_need.name_en) }}</div>
          </template>
          <template v-slot:item.date="{ item }">
            <div>{{ new Date(item.project_start_date).toLocaleDateString("en-GB") }} - {{ new Date(item.project_end_date).toLocaleDateString("en-GB") }} </div>
          </template>
           <template v-slot:item.project_owner="{ item }">
            <div>{{ getTranslation(item.project_need.project_owner.name) }}</div>
          </template>
          <template v-slot:item.project_sector="{ item }">
            <div>{{ getTranslation(item.project_need.project_sector.translation.name) }}</div>
          </template>
          <template v-slot:item.cost="{ item }">
            <div v-if="item.project_budgets.length !== 0">{{ item.project_budgets[0].amount.toLocaleString() }}</div>
            <div v-else>0</div>
          </template>
          <template v-slot:item.total_payment="{ item }">
            <div>{{ item.total_payment.toLocaleString() }}</div>
          </template>
          <template v-slot:item.location="{ item }">
            <div v-if="item.project_need.province !== null">{{ getTranslation(item.project_need.province.translation.name) }}</div>
            <div v-if="item.project_need.district !== null">{{ getTranslation(item.project_need.district.translation.name) }}</div>
            <div v-if="item.project_need.village !== null">{{ getTranslation(item.project_need.village.translation.name) }}</div>
          </template>
          <template v-slot:item.asset_type="{ item }">
            <div v-if="item.project_need !== null">{{ getTranslation(item.project_need.affected_asset_needs[0].affected_asset.asset_type.translation.name) }}</div>
          </template>
          <template slot="body.append">
              <tr>
                  <th style="text-align:center;">{{ $t('Total') }}</th>
                  <th style="text-align:center;">{{ proj.length }} {{ $t('Projects') }}</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th style=" text-align:left;">{{ proj[0].totalCost.toLocaleString() }} <!--{{ $t('mLAK') }}--></th>
                  <th style=" text-align:left;">{{ proj[0].totalPayment.toLocaleString() }} <!--{{ $t('mLAK') }}--></th>
              </tr>
          </template>

        </v-data-table>
      </material-card>
    </div>

    <!----------DISASTER TABLE-------------------->
    <!--<div v-for="(dis,id) in disasterResult" :key="dis.id" v-if="category === 'Disaster' ">
      <material-card
        icon="mdi-weather-lightning"
        icon-small
        :title="dis[0].type"
        color="#ff7c00"
        :subtitle="$t('Disasters')"
      >
        <v-data-table
          :headers="disasterHeaders"
          :items="dis" 
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="name"
          show-expand
        >
        <template v-for="header in disasterHeaders" v-slot:[`header.${header.value}`]="{ header }">
            <span>{{ getHeader(header.text) }}</span>
          </template>
          <template v-slot:item.name="{ item }">
            <div>{{ getTranslation(item.name) }}</div>
          </template>
           <template v-slot:item.year="{ item }">
            <div>{{ getTranslation(item.year) }}</div>
          </template>
           <template v-slot:item.type="{ item }">
            <div>{{ getTranslation(item.type) }}</div>
          </template>
        <template v-slot:item.cost="{ item }">
            <div>{{ item.cost.toLocaleString() }}</div>
          </template>
          
          <template v-slot:item.location="{ item }">
            <div v-for="(prov,province_id) in item.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.name_en) }}</div>
            <div v-for="(dist,district_id) in item.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.name_en) }}</div>
          </template>
          <template v-slot:item.affectedPopulation="{ item }">
            <div>{{ item.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
            <div>{{ item.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
            <div>{{ item.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
          </template>
          <template v-slot:item.totalDeath="{ item }">
            <div>{{ item.total_death.toLocaleString() }} {{ $t('people') }}</div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" style="background-color:#eeeeee;">
              <v-simple-table>
                <tbody>
                  <tr v-for="(proj,id) in item.projects" :key="proj.id" style="background-color:#eeeeee;">
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">{{ getTranslation(proj.name) }}</td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">{{ proj.date }}</td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">{{ getTranslation(proj.asset) }}</td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">
                        <div v-for="(prov,province_id) in proj.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.name_en) }}</div>
                        <div v-for="(dist,district_id) in proj.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.name_en) }}</div>
                    </td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">{{ proj.cost.toLocaleString() }} {{ $t('mLAK') }}</td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">          
                      <div>{{ proj.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
                      <div>{{ proj.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
                      <div>{{ proj.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
                    </td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">          
                      <div>{{ proj.total_death.toLocaleString() }} {{ $t('people') }}</div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr style="background-color:#eeeeee;">
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }"></td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }"></td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }"></td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }"></td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">{{ $t('Total') }}: 126,010.17 {{ $t('mLAK') }}</td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">
                      {{ $t('Total') }}:
                      <div>38 {{ $t('people') }}</div>
                      <div>12 {{ $t('women') }}</div> 
                      <div>10 {{ $t('household') }}</div> 
                    </td>
                    <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">
                      {{ $t('Total') }}:
                      <div>302 {{ $t('people') }}</div>
                    </td>
                  </tr>
                </tfoot>
              </v-simple-table>
            </td>
          </template>
          <template slot="body.append">
              <tr>
                  <th style="text-align:center;">{{ $t('Total') }}</th>
                  <th style="text-align:center;">{{ dis.length }} {{ $t('Disasters') }}</th>
                  <th></th>
                  <th style=" text-align:center;">{{ dis[0].totalCost.toLocaleString() }}</th>
                  <th></th>
                  <th></th>
              </tr>
          </template>

        </v-data-table>
      </material-card>
    </div>-->

    <!--<material-card v-if="category === 'Disaster' "
      icon="mdi-weather-lightning"
      icon-small
      title="Disaster Table 2 Back up"
      color="accent"
    >
      <v-data-table
        :headers="disasterHeaders"
        :items="disasters" 
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        item-key="name"
        show-expand
      >
      <template v-for="header in disasterHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
      <template v-slot:item.cost="{ item }">
          <div>{{ item.cost.toLocaleString() }}</div>
        </template>
        <template v-slot:item.location="{ item }">
          <div v-for="(prov,province_id) in item.disaster_provinces" :key="prov.province_id">{{ prov.name_en }}</div>
          <div v-for="(dist,district_id) in item.disaster_districts" :key="dist.district_id">{{ dist.name_en }}</div>
        </template>
        <template v-slot:item.affectedPopulation="{ item }">
          <div>{{ item.total_affected_people.toLocaleString() }} people</div>
          <div>{{ item.total_affected_woman.toLocaleString() }} women</div> 
          <div>{{ item.total_affected_family.toLocaleString() }} household</div>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" style="background-color:#eeeeee;">
            <v-simple-table>
              <tbody>
                <tr v-for="(proj,id) in item.projects" :key="proj.id" style="background-color:#eeeeee;">
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">{{ proj.name }}</td>
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">{{ proj.date }}</td>
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">{{ proj.asset }}</td>
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">
                      <div v-for="(prov,province_id) in proj.disaster_provinces" :key="prov.province_id">{{ prov.name_en }}</div>
                      <div v-for="(dist,district_id) in proj.disaster_districts" :key="dist.district_id">{{ dist.name_en }}</div>
                  </td>
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">{{ proj.cost.toLocaleString() }} mLAK</td>
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">          
                    <div>{{ proj.total_affected_people.toLocaleString() }} people</div>
                    <div>{{ proj.total_affected_woman.toLocaleString() }} women</div> 
                    <div>{{ proj.total_affected_family.toLocaleString() }} household</div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr style="background-color:#eeeeee;">
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }"></td>
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }"></td>
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }"></td>
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }"></td>
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">Total: 126,010.17 mLAK</td>
                  <td :style="{ 'background-color': hover ? '#eeeeee' : '#eeeeee' }">
                    Total:
                    <div>38 people</div>
                    <div>12 women</div> 
                    <div>10 household</div> 
                  </td>
                </tr>
              </tfoot>
            </v-simple-table>
          </td>
        </template>
        <template slot="body.append">
            <tr>
                <th style="text-align:center;">Total:</th>
                <th style="text-align:center;">2 Disasters</th>
                <th></th>
                <th style=" text-align:center;">133,000</th>
                <th></th>
                <th></th>
            </tr>
        </template>

      </v-data-table>
    </material-card>-->


    <!----------ASSET TABLE-------------------->
    <!--<material-card v-if="category === 'Asset' "
      icon="mdi-road-variant"
      icon-small
      title="Road"
      color="#e67300"
    >
      <v-data-table
        :headers="assetHeaders"
        :items="roads" 
      >
      <template v-for="header in assetHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
      <template v-slot:item.cost="{ item }">
          <div>{{ item.cost.toLocaleString() }}</div>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>  
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>  
        <template v-slot:item.project="{ item }">
          <div>{{ getTranslation(item.project) }}</div>
        </template>  
        <template v-slot:item.location="{ item }">
          <div v-for="(prov,province_id) in item.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.name_en) }}</div>
          <div v-for="(dist,district_id) in item.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.name_en) }}</div>
        </template>
        <template v-slot:item.beneficiary="{ item }">
          <div>{{ item.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
          <div>{{ item.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
          <div>{{ item.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
        </template>
        <template slot="body.append">
            <tr>
                <th style="text-align:center;">{{ $t('Total') }}</th>
                <th style="text-align:center;">2 {{ $t('Affected Roads') }}</th>
                <th></th>
                <th></th>
                <th style=" text-align:center;">39,000</th>
                <th></th>
            </tr>
        </template>
      </v-data-table>
    </material-card>-->

    <!--<material-card v-if="category === 'Asset' "
      icon="mdi-bridge"
      icon-small
      title="Bridge"
      color="#f59e32"
    >
      <v-data-table
        :headers="assetHeaders"
        :items="bridges" 
      >
      <template v-for="header in assetHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>  
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>  
        <template v-slot:item.project="{ item }">
          <div>{{ getTranslation(item.project) }}</div>
        </template>  
      <template v-slot:item.cost="{ item }">
          <div>{{ item.cost.toLocaleString() }}</div>
        </template>
        <template v-slot:item.location="{ item }">
          <div v-for="(prov,province_id) in item.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.name_en) }}</div>
          <div v-for="(dist,district_id) in item.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.name_en) }}</div>
        </template>
        <template v-slot:item.beneficiary="{ item }">
          <div>{{ item.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
          <div>{{ item.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
          <div>{{ item.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
        </template>
        <template slot="body.append">
            <tr>
                <th style="text-align:center;">{{ $t('Total') }}</th>
                <th style="text-align:center;">1 {{ $t('Affected Bridge') }}</th>
                <th></th>
                <th></th>
                <th style=" text-align:center;">438,000</th>
                <th></th>
            </tr>
        </template>
      </v-data-table>
    </material-card>

    <material-card v-if="category === 'Asset' "
      icon="mdi-water-pump"
      icon-small
      title="Irrigation"
      color="#0057d9"
    >
      <v-data-table
        :headers="assetHeaders"
        :items="irrigations" 
      >
      <template v-for="header in assetHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>  
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>  
        <template v-slot:item.project="{ item }">
          <div>{{ getTranslation(item.project) }}</div>
        </template>  
      <template v-slot:item.cost="{ item }">
          <div>{{ item.cost.toLocaleString() }}</div>
        </template>
        <template v-slot:item.location="{ item }">
          <div v-for="(prov,province_id) in item.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.name_en) }}</div>
          <div v-for="(dist,district_id) in item.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.name_en) }}</div>
        </template>
        <template v-slot:item.beneficiary="{ item }">
          <div>{{ item.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
          <div>{{ item.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
          <div>{{ item.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
        </template>
        <template slot="body.append">
            <tr>
                <th style="text-align:center;">{{ $t('Total') }}</th>
                <th style="text-align:center;">1 {{ $t('Affected Irrigation') }}</th>
                <th></th>
                <th></th>
                <th style=" text-align:center;">52,000</th>
                <th></th>
            </tr>
        </template>
      </v-data-table>
    </material-card>

    <material-card v-if="category === 'Asset' "
      icon="mdi-hospital-box-outline"
      icon-small
      title="Hospital"
      color="#dc143c"
    >
      <v-data-table
        :headers="assetHeaders"
        :items="hospitals" 
      >
      <template v-for="header in assetHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>  
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>  
        <template v-slot:item.project="{ item }">
          <div>{{ getTranslation(item.project) }}</div>
        </template>  
      <template v-slot:item.cost="{ item }">
          <div>{{ item.cost.toLocaleString() }}</div>
        </template>
        <template v-slot:item.location="{ item }">
          <div v-for="(prov,province_id) in item.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.name_en) }}</div>
          <div v-for="(dist,district_id) in item.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.name_en) }}</div>
        </template>
        <template v-slot:item.beneficiary="{ item }">
          <div>{{ item.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
          <div>{{ item.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
          <div>{{ item.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
        </template>
        <template slot="body.append">
            <tr>
                <th style="text-align:center;">{{ $t('Total') }}</th>
                <th style="text-align:center;">1 {{ $t('Affected Hospital') }}</th>
                <th></th>
                <th></th>
                <th style=" text-align:center;">6,000</th>
                <th></th>
            </tr>
        </template>
      </v-data-table>
    </material-card>

    <material-card v-if="category === 'Asset' "
      icon="mdi-school"
      icon-small
      title="School"
      color="#2da14c"
    >
      <v-data-table
        :headers="assetHeaders"
        :items="schools" 
      >
      <template v-for="header in assetHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>  
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>  
        <template v-slot:item.project="{ item }">
          <div>{{ getTranslation(item.project) }}</div>
        </template>  
      <template v-slot:item.cost="{ item }">
          <div>{{ item.cost.toLocaleString() }}</div>
        </template>
        <template v-slot:item.location="{ item }">
          <div v-for="(prov,province_id) in item.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.name_en) }}</div>
          <div v-for="(dist,district_id) in item.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.name_en) }}</div>
        </template>
        <template v-slot:item.beneficiary="{ item }">
          <div>{{ item.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
          <div>{{ item.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
          <div>{{ item.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
        </template>
        <template slot="body.append">
            <tr>
                <th style="text-align:center;">{{ $t('Total') }}</th>
                <th style="text-align:center;">1 {{ $t('Affected School') }}</th>
                <th></th>
                <th></th>
                <th style=" text-align:center;">6,000</th>
                <th></th>
            </tr>
        </template>
      </v-data-table>
    </material-card>

    <material-card v-if="category === 'Asset' "
      icon="mdi-office-building"
      icon-small
      title="Public Building"
      color="#8b4513"
    >
      <v-data-table
        :headers="assetHeaders"
        :items="publicBuildings" 
      >
      <template v-for="header in assetHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>  
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>  
        <template v-slot:item.project="{ item }">
          <div>{{ getTranslation(item.project) }}</div>
        </template>  
      <template v-slot:item.cost="{ item }">
          <div>{{ item.cost.toLocaleString() }}</div>
        </template>
        <template v-slot:item.location="{ item }">
          <div v-for="(prov,province_id) in item.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.name_en) }}</div>
          <div v-for="(dist,district_id) in item.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.name_en) }}</div>
        </template>
        <template v-slot:item.beneficiary="{ item }">
          <div>{{ item.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
          <div>{{ item.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
          <div>{{ item.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
        </template>
        <template slot="body.append">
            <tr>
                <th style="text-align:center;">{{ $t('Total') }}</th>
                <th style="text-align:center;">1 {{ $t('Affected Public Building') }}</th>
                <th></th>
                <th></th>
                <th style=" text-align:center;">2,000</th>
                <th></th>
            </tr>
        </template>
      </v-data-table>
    </material-card>

    <material-card v-if="category === 'Asset' "
      icon="mdi-cog"
      icon-small
      title="Equipment"
      color="#7900c7"
    >
      <v-data-table
        :headers="assetHeaders"
        :items="equipments" 
      >
      <template v-for="header in assetHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>  
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>  
        <template v-slot:item.project="{ item }">
          <div>{{ getTranslation(item.project) }}</div>
        </template>  
      <template v-slot:item.cost="{ item }">
          <div>{{ item.cost.toLocaleString() }}</div>
        </template>
        <template v-slot:item.location="{ item }">
          <div v-for="(prov,province_id) in item.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.name_en) }}</div>
          <div v-for="(dist,district_id) in item.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.name_en) }}</div>
        </template>
        <template v-slot:item.beneficiary="{ item }">
          <div>{{ item.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
          <div>{{ item.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
          <div>{{ item.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
        </template>
        <template slot="body.append">
            <tr>
                <th style="text-align:center;">{{ $t('Total') }}</th>
                <th style="text-align:center;">1 {{ $t('Affected Equipment') }}</th>
                <th></th>
                <th></th>
                <th style=" text-align:center;">7,000</th>
                <th></th>
            </tr>
        </template>
      </v-data-table>
    </material-card>-->

    <!----------LOCATION TABLE-------------------->
    <!--<material-card v-if="category === 'Location' "
      icon="mdi-map-marker"
      icon-small
      title="Location"
      color="accent"
    >
      <v-data-table
        :headers="locationHeaders"
        :items="locations" 
      >
        <template v-for="header in locationHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.disaster_cost="{ item }">
          <div>{{ item.disaster_cost.toLocaleString() }}</div>
        </template>
        <template v-slot:item.budget="{ item }">
          <div>{{ item.budget.toLocaleString() }}</div>
        </template>
        <template v-slot:item.expense="{ item }">
          <div>{{ item.expense.toLocaleString() }}</div>
        </template>
        <template v-slot:item.beneficiary="{ item }">
          <div>{{ item.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
          <div>{{ item.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
          <div>{{ item.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
        </template>
        <template slot="body.append">
            <tr>
                <th style="text-align:center;">{{ $t('Total') }}</th>
                <th style="text-align:center;">17 {{ $t('Disasters') }}</th>
                <th style="text-align:center;">1,163,000</th>
                <th style="text-align:center;">82 {{ $t('Projects') }}</th>
                <th style=" text-align:center;">7,000</th>
                <th style=" text-align:center;">587,000</th>
                <th></th>
            </tr>
        </template>
      </v-data-table>
    </material-card>-->


  </v-container>
</template>

<script>
  //import axios from 'axios'
  export default {
    name: 'DashboardTable',
    props: {
      year: {
        type: Array
      },
      owner: {
        type: Array
      },
      sector: {
        type: Array
      },
      /*disaster: {
        type: Array
      },
      asset: {
        type: Array
      },*/
      location: {
        type: Array
      },
      category: {
        type: String
      }
    },
    /*mounted: function(){
      this.category = 'Project';
    },*/
    data: () => ({
      projectHeaders: [
        {
          sortable: true,
          text: 'Project ID',
          align: 'center',
          value: 'project_number',
        },{
          sortable: true,
          text: 'Name',
          align: 'center',
          value: 'name',
        },{
          sortable: true,
          text: 'Sector',
          align: 'center',
          value: 'project_sector',
        },{
          sortable: true,
          text: 'Project Period',
          align: 'center',
          value: 'date',
        },{
          sortable: true,
          text: 'Project Owner',
          align: 'center',
          value: 'project_owner',
        },{
          sortable: true,
          text: 'Location',
          align: 'center',
          value: 'location',
          width: '8%'
        },{
          sortable: true,
          text: 'Asset Category',
          align: 'center',
          value: 'asset_type',
        },{
          sortable: true,
          text: 'Project contract value (mLAK)',
          align: 'left',
          value: 'cost',
          width: '7%'
        },{
          sortable: true,
          text: 'Total Payment (mLAK)',
          align: 'left',
          value: 'total_payment',
          width: '7%'
        },
        /*{
          sortable: true,
          text: 'Asset',
          align: 'center',
          value: 'asset',
        },*/
        /*{
          sortable: true,
          text: 'Location',
          align: 'center',
          value: 'location',
        },*/
        /*{
          sortable: true,
          text: 'Disaster',
          align: 'center',
          value: 'disaster'
        },*/
        /*{
          sortable: false,
          text: 'Number of Beneficiary',
          align: 'center',
          value: 'beneficiary'
        }*/
      ],
      selectedOwnerList: [],
      selectedSectorList: [],
      selectedYearList: [],
      selectedLocationList: [],
      expanded: [],
      singleExpand: false,  

      /*disasterHeaders: [
        { text: '', value: 'data-table-expand' },
        {
          sortable: true,
          text: 'Name',
          align: 'center',
          value: 'name',
          groupable: false
        },
        {
          sortable: true,
          text: 'Year',
          align: 'center',
          value: 'year'
        },
        {
          sortable: true,
          text: 'Cost (mLAK)',
          align: 'center',
          value: 'cost',
        },
        {
          sortable: true,
          text: 'Location',
          align: 'center',
          value: 'location',
        },
        {
          sortable: true,
          text: 'Affected Population',
          align: 'center',
          value: 'affectedPopulation',
        },
        {
          sortable: true,
          text: 'Death',
          align: 'center',
          value: 'totalDeath',
        }
      ],
      assetHeaders: [
        {
          sortable: true,
          text: 'Name',
          align: 'center',
          value: 'name',
        },
        {
          sortable: true,
          text: 'Disaster',
          align: 'center',
          value: 'disaster',
        },
        {
          sortable: true,
          text: 'Project',
          align: 'center',
          value: 'project',
        },
        {
          sortable: true,
          text: 'Location',
          align: 'center',
          value: 'location',
        },
        {
          sortable: false,
          text: 'Cost (mLAK)',
          align: 'center',
          value: 'cost',
        },
        {
          sortable: false,
          text: 'Number of Beneficiary',
          align: 'center',
          value: 'beneficiary'
        }
      ],
      locationHeaders: [
        {
          sortable: true,
          text: 'Province',
          align: 'center',
          value: 'name',
        },
        {
          sortable: true,
          text: 'Disaster',
          align: 'center',
          value: 'disaster_nb',
        },
        {
          sortable: true,
          text: 'Cost (mLAK)',
          align: 'center',
          value: 'disaster_cost',
        },
        {
          sortable: true,
          text: 'Project',
          align: 'center',
          value: 'project_nb',
        },
        {
          sortable: false,
          text: 'Budget (mLAK)',
          align: 'center',
          value: 'budget',
        },
        {
          sortable: false,
          text: 'Expense (mLAK)',
          align: 'center',
          value: 'expense',
        },
        {
          sortable: false,
          text: 'Number of Beneficiary',
          align: 'center',
          value: 'beneficiary'
        }
      ],*/
      /*projects: [
        {
          id:1,
          name: 'Rehabilitation and Improvement',
          date: '2018 - 2020',
          asset: '7001 - Road 13N',
          asset_name: 'Road',
          disaster_provinces: [{id: 1,name: 'Vientiane Capital'},{id: 6,name: 'Luang Prabang'}],
          cost: 120000,
          disaster: 'Flood 2018',
          dis_id: 2,
          total_affected_people: 36,
          total_affected_woman: 2,
          total_affected_family: 2,
          year: 2018,
          year_id: 4
        },      
        {
          id: 2,
          name: 'Reconstruction Road',
          date: '2016 - 2020',
          asset: '7002 - Road 13S',
          asset_name: 'Road',
          disaster_provinces: [{id: 10,name: 'Vientiane'}],
          cost: 96000,
          disaster: 'Tropical Cyclone Dianmu',
          dis_id:4,
          total_affected_people: 3,
          total_affected_woman: 1,
          total_affected_family: 1,
          year: 2016,
          year_id:2
        },      
        {
          id: 3,
          name: 'Reconstruction Road 2',
          date: '2016 - 2020',
          asset: '7002 - Road 13S',
          asset_name: 'Road',
          disaster_provinces: [{id: 10,name: 'Vientiane'}],
          cost: 96000,
          disaster: 'Tropical Cyclone Dianmu',
          dis_id:4,
          total_affected_people: 3,
          total_affected_woman: 1,
          total_affected_family: 1,
          year: 2016,
          year_id:2
        }
      ],*/
      projectResult: [],
      //disasterResult: [],
      //projectOrdered: [],
      /*disasters: [
        {
          name: 'Flood 2018',
          type: 'Flood',
          type_id: 2,
          year: 2018,
          year_id: 4,
          asset_name: 'Road',
          cost: 120000,
          disaster_provinces: [{id: 1,name_en: 'Vientiane Capital'},{id: 6,name_en: 'Luang Prabang'}],
          total_affected_people: 41,
          total_affected_woman: 20,
          total_affected_family: 15,
          total_death: 302,
          projects: [
            {
              name: 'Rehabilitation and Improvement',
              date: '01/01/2021',
              asset: '7001 - Road 13N',
              disaster_provinces: [{id: 6,name_en: 'Luang Prabang'}],
              cost: 120000,
              total_affected_people: 36,
              total_affected_woman: 2,
              total_affected_family: 2,
              total_death: 152
            },      
            {
              name: 'Reconstruction Road',
              date: '01/02/2021',
              asset: '7002 - Road 13S',
              disaster_provinces: [{id: 1,name_en: 'Vientiane Capital'}],
              cost: 96000,
              total_affected_people: 3,
              total_affected_woman: 1,
              total_affected_family: 1,
              total_death: 150
            }
          ]
        },       
        {
          name: 'Tropical Cyclone Dianmu',
          type: 'Cyclone',
          type_id: 4,
          year: 2016,
          year_id:2,
          asset_name: 'Road',
          cost: 13000,
          disaster_provinces: [{id: 6,name_en: 'Luang Prabang'}],
          total_affected_people: 6,
          total_affected_woman: 2,
          total_affected_family: 2,
          total_death: 302,
          projects: [            
          {
              name: 'Rehabilitation and Improvement',
              date: '01/01/2021',
              asset: '51 - Friendship Bridge',
              disaster_provinces: [{id: 6,name_en: 'Luang Prabang'}],
              cost: 11000,
              total_affected_people: 36,
              total_affected_woman: 2,
              total_affected_family: 2,
              total_death: 302
            }
          ]
        },       
        {
          name: 'Tropical Cyclone Dianmu 2',
          type: 'Cyclone',
          type_id:4,
          year: 2017,
          year_id:3,
          asset_name: 'Road',
          cost: 14000,
          disaster_provinces: [{id: 6,name_en: 'Luang Prabang'}],
          total_affected_people: 7,
          total_affected_woman: 3,
          total_affected_family: 3,
          total_death: 302,
          projects: [            
          {
              name: 'Rehabilitation and Improvement 2',
              date: '01/01/2017',
              asset: '7002 - Road 13S',
              disaster_provinces: [{id: 6,name_en: 'Luang Prabang'}],
              cost: 12000,
              total_affected_people: 360,
              total_affected_woman: 20,
              total_affected_family: 27,
              total_death: 302
            }
          ]
        }
      ],
      disasterOrdered: [],
      roads: [
        {
          name: '7001 - 13N Road',
          disaster: 'Flood 2018',
          project: 'Reconstruction Road',
          disaster_provinces: [{id: 1,name_en: 'Vientiane Capital'},{id: 6,name_en: 'Luang Prabang'}],
          cost: 36000,
          total_affected_people: 360,
          total_affected_woman: 240,
          total_affected_family: 20
        },
        {
          name: '7002 - 13S Road',
          disaster: 'Tropical Cyclone Dianmu',
          project: 'Reconstruction Road',
          disaster_provinces: [{id: 10,name_en: 'Vientiane'}],
          cost: 3000,
          total_affected_people: 3,
          total_affected_woman: 0,
          total_affected_family: 0
        }
      ],
      bridges: [
        {
          name: '51 - Friendship Bridge',
          disaster: 'Flood 2018',
          project: 'Rehabilitation and Improvement',
          disaster_provinces: [{id: 6,name_en: 'Luang Prabang'}],
          cost: 438000,
          total_affected_people: 36,
          total_affected_woman: 2,
          total_affected_family: 2
        }
      ],
      irrigations: [
        {
          name: '11 - Irrigation Phongsali',
          disaster: 'Flood 2018',
          project: 'Rehabilitation and Improvement',
          disaster_provinces: [{id: 1,name_en: 'Phongsali'}],
          cost: 52000,
          total_affected_people: 462,
          total_affected_woman: 295,
          total_affected_family: 200
        }
      ],
      hospitals: [
        {
          name: '21 - Houaphan Hospital',
          disaster: 'Tropical Cyclone Dianmu',
          project: 'Rehabilitation and Improvement',
          disaster_provinces: [{id: 13,name_en: 'Houphan'}],
          cost: 6000,
          total_affected_people: 60,
          total_affected_woman: 20,
          total_affected_family: 20
        }
      ],
      schools: [
        {
          name: '31 - Luang Prabang University',
          disaster: 'Tropical Cyclone Dianmu',
          project: 'Rehabilitation and Improvement',
          disaster_provinces: [{id: 13,name_en: 'Savanakhet'},{id: 6,name_en: 'Luang Prabang'}],
          cost: 6000,
          total_affected_people: 60,
          total_affected_woman: 20,
          total_affected_family: 20
        }
      ],
      publicBuildings : [
        {
          name: '41 - Vientiane Office LAK 40',
          disaster: 'Tropical Cyclone Dianmu',
          project: 'Rehabilitation and Improvement',
          disaster_provinces: [{id: 10,name_en: 'Vientiane'}],
          cost: 2000,
          total_affected_people: 62,
          total_affected_woman: 19,
          total_affected_family: 14
        }
      ],
      equipments: [
        {
          name: '310 - Pump 302 - Sapanthong Area',
          disaster: 'Tropical Cyclone Dianmu',
          project: 'Rehabilitation and Improvement',
          disaster_provinces: [{id: 13,name_en: 'Savanakhet'},{id: 6,name_en: 'Luang Prabang'}],
          cost: 7000,
          total_affected_people: 601,
          total_affected_woman: 202,
          total_affected_family: 202
        }
      ],
      locations: [
        {
          id: 1,
          name: 'Vientiane Capital',
          disaster_nb: 3,
          disaster_cost: 650000,
          project_nb: 56,
          budget: 512000,
          expense: 489000,
          total_affected_people: 652,
          total_affected_woman: 425,
          total_affected_family: 300
        },        
        {
          id: 13,
          name: 'Savannakhet',
          disaster_nb: 5,
          disaster_cost: 453000,
          project_nb: 21,
          budget: 56000,
          expense: 42000,
          total_affected_people: 65,
          total_affected_woman: 45,
          total_affected_family: 30
        },        
        {
          id: 5,
          name: 'Bokeo',
          disaster_nb: 9,
          disaster_cost: 60000,
          project_nb: 5,
          budget: 78000,
          expense: 56000,
          total_affected_people: 52,
          total_affected_woman: 25,
          total_affected_family: 7
        }
      ],*/
    }),
    mounted: function(){
      //this.expanded = this.disasters;
      //this.getDisasterFiltered(this.disasters);
      this.$store.dispatch('projects/getProjectCompletedList');
      //this.getProjectOrdered(this.projects);
      //this.getDisasterOrdered(this.disasters);
    },
    watch: {
      projectCompletedList: function(){
        this.projectResult = this.projectCompletedList;
        this.getProjectOrdered(this.projectCompletedList);
      },
      category: function(category){
        this.selectedCategory = category;
      },
      owner: function(owners){
        //console.log('owners', owners);
        this.selectedOwnerList = owners;
        this.getProjectFiltered();
        //this.getDisasterFiltered('year', years);
      },
      sector: function(sectors){
        //console.log('sectors', sectors);
        this.selectedSectorList = sectors;
        this.getProjectFiltered();
        //this.getDisasterFiltered('year', years);
      },
      year: function(years){
        //console.log('years', years);
        this.selectedYearList = years;
        this.getProjectFiltered();
        //this.getDisasterFiltered('year', years);
      },
      location: function(provinces){
        //console.log('provinces', provinces);
        this.selectedLocationList = provinces;
        this.getProjectFiltered();
        //this.getDisasterFiltered('location', provinces);
    
      },
      /*projects: function() {
          if(this.$store.state.projects.projects.length !== 0){
            this.getProjectFiltered(0);
          }
        },*/
      /*disaster: function(disasters){
        this.selectedDisaster = disasters;
        //this.getProjectFiltered();
        //this.getDisasterFiltered('disaster', disasters);
      },
      asset: function(assets){
        this.selectedAsset = assets;
        this.getProjectFiltered();
        //this.getDisasterFiltered('asset',assets);
      },*/
    },
    computed:{
      /*total(){
        const sums = {
            projectTotalCost: 0,
            projectTotalAffectedPeople: 0,
            projectTotalAffectedWoman: 0,
            projectTotalAffectedFamily: 0
        }
        this.disasters.forEach(({projectCost, projectAffectedPeople, projectAffectedWoman, projectAffectedFamily}) => {
           sums.projectTotalCost += projectCost;
           sums.projectTotalAffectedPeople += projectAffectedPeople;
           sums.projectTotalAffectedWoman += projectAffectedWoman;
           sums.projectTotalAffectedFamily += projectAffectedFamily;
        })
        return sums
      },*/
      projectCompletedList() {
        return this.$store.state.projects.projectCompletedList;
      },
    },
    /*mounted: function(){
      this.formatRowDisasterTable();
      //this.$store.dispatch('disasters/getDisasters');
    },*/
    methods: {
      getHeader(val) {
        return this.$t(val);
      },
      getTranslation(val) {
        return this.$t(val);
      },
      getProjectOrdered(list){
        this.projectResult = [];
        //var yearTab =  Array.from(new Set(list.map((item) => item.project_need.year.name)));
        var yearTab =  Array.from(new Set(list.map((item) => new Date(item.project_start_date).getFullYear() )));
        for(var i=0; i < yearTab.length; i++){
          //var tab = list.filter(proj => proj.project_need.year.name === yearTab[i]);
          var tab = list.filter(proj => new Date(proj.project_start_date).getFullYear() === yearTab[i]);
          tab[0].totalCost = tab.map(function(item) {
            if(item.project_budgets.length !== 0){
               return item.project_budgets[0].amount;
            }else{
              return 0;
            }
          }).reduce((prev, curr) => prev + curr, 0);
          tab[0].totalPayment = tab.map(item => item.total_payment).reduce((prev, curr) => prev + curr, 0);
          this.projectResult.push(tab);

        }
      },
      /*getDisasterOrdered(list){
        this.disasterResult = [];
        var typeTab =  Array.from(new Set(list.map((item) => item.type)));
        for(var i=0; i < typeTab.length; i++){
          var tab = list.filter(dis => dis.type === typeTab[i]);
          tab[0].totalCost = tab.map(item => item.cost).reduce((prev, curr) => prev + curr, 0);
          this.disasterResult.push(tab);
        }
      },*/
      getProjectFiltered(){
        
        var projOwnerTemp = [];
        var projSectorTemp = [];
        var projYearTemp = [];
        var projProvTemp = [];

        var projTemp = [];
        if(this.selectedOwnerList.length !== 0 
            || this.selectedSectorList.length !== 0 
            || this.selectedYearList.length !== 0 
            || this.selectedLocationList.length !== 0){

          //Owner Mgt
          if(this.selectedOwnerList.length !== 0){
            for(var i=0; i < this.selectedOwnerList.length; i++){
              for(var j=0; j < this.projectCompletedList.length; j++){
                if(this.selectedOwnerList[i] === this.projectCompletedList[j].project_need.project_owner.id){
                  projOwnerTemp.push(this.projectCompletedList[j]);
                }
              }
            }
          }else{
            projOwnerTemp = this.projectCompletedList;
          }

          //sector Mgt
          if(this.selectedSectorList.length !== 0){
            for(var i=0; i < this.selectedSectorList.length; i++){
              for(var j=0; j < this.projectCompletedList.length; j++){
                if(this.selectedSectorList[i] === this.projectCompletedList[j].project_need.project_sector.id){
                  projSectorTemp.push(this.projectCompletedList[j]);
                }
              }
            }
          }else{
            projSectorTemp = this.projectCompletedList;
          }

          //year Mgt
          if(this.selectedYearList.length !== 0){
            for(var i=0; i < this.selectedYearList.length; i++){
              for(var j=0; j < this.projectCompletedList.length; j++){
                //if(this.selectedYearList[i] === this.projectCompletedList[j].project_need.year.id){
                  if (this.selectedYearList[i] === new Date(this.projectCompletedList[j].project_start_date).getFullYear()) {
                    projYearTemp.push(this.projectCompletedList[j]);
                  
                  }
              }
            }
          }else{
            projYearTemp = this.projectCompletedList;
          }

          //location Mgt
          if(this.selectedLocationList.length !== 0){
            for(var i=0; i < this.selectedLocationList.length; i++){
              for(var j=0; j < this.projectCompletedList.length; j++){
                //console.log('this.projectCompletedList[j].project_need', this.projectCompletedList[j].project_need);
                if(
                  (this.projectCompletedList[j].project_need.province !== null && this.selectedLocationList[i] === this.projectCompletedList[j].project_need.province_id) ||
                  (this.projectCompletedList[j].project_need.district !== null && this.selectedLocationList[i] === this.projectCompletedList[j].project_need.district.province_id) ||
                  (this.projectCompletedList[j].project_need.village !== null && this.selectedLocationList[i] === this.projectCompletedList[j].project_need.village.province_id)
                ){
                      projProvTemp.push(this.projectCompletedList[j]);
                }
              }
            }
          }else{
            projProvTemp = this.projectCompletedList;
          }

          //Remove duplicate project
          //projTemp = Array.from(new Set(projTemp.map(JSON.stringify))).map(JSON.parse);

          var data = [projOwnerTemp, projSectorTemp, projYearTemp, projProvTemp];
          projTemp = data.reduce((a, b) => a.filter(c => b.includes(c)));

        }else{
          projTemp = this.projectCompletedList;
        }

        this.getProjectOrdered(projTemp);

      },
      /*getDisasterFiltered(categoryInput, valueInput){
          var disTemp2 = [];
          var disTemp = [];
          var disYear = [];
          var disDis = [];
          var disAsset = [];
        if(categoryInput === 'location'){
          
            //console.log('location')
            if(valueInput.length !== 0){
              //console.log(valueInput)
              this.disasters.forEach(function(dis) {
                 
                var test = false;
                disTemp = dis.disaster_provinces.filter((elem) => {
                  if(test === false){
                    test = valueInput.some((ele) => {
                      return ele === elem.id;
                    });
                  }
                });
                if(test === true){
                  //console.log('****TEST TRUE');
                  disTemp2.push(dis);
                  test = false;
                }
              });
              this.disasterResult = disTemp2;
            }else{
              this.disasterResult = this.disasters;
            }
        }
         else if(categoryInput === 'year'){
          //console.log('pro')
              if(valueInput.length !== 0){
                    this.disasters.forEach(function(dis) {
                        //console.log(valueInput[year_index])
                      
                        for ( let year_index = 0; year_index < valueInput.length; year_index++){
                             if(valueInput[year_index]  === dis.year_id){
                                  //console.log('Test function')
                                   disYear.push(dis);
                             }
                        }
                   
                  
                    });
                   this.disasterResult = disYear;
                  }
                   else{
                    this.disasterResult = this.disasters;
                  }  
         }
         else if(categoryInput === 'disaster'){
            
            if(valueInput.length !== 0){
              this.disasters.forEach(function(dis) {
                //console.log(valueInput)
                 for ( let dis_index = 0; dis_index < valueInput.length; dis_index++){
                             if(valueInput[dis_index]  === dis.type_id){
                                  //console.log('Test function')
                                   disDis.push(dis);
                             }
                        }
              });
              this.disasterResult = disDis;
            }
            else{this.disastersResult = this.disasters;}
         }
         else if(categoryInput === 'asset'){
              
              if(valueInput.length !== 0){
                this.disasters.forEach(function(dis) {
                  console.log(valueInput)
                   for ( let asset_index = 0; asset_index < valueInput.length; asset_index++){
                             if(valueInput[asset_index]  === dis.asset_name){
                                  //console.log('Test function')
                                   disAsset.push(dis);
                             }
                        }
                });
                this.disasterResult = disAsset;
              }
              else{this.disasterResult = this.disasters;}
         }
       

        this.getDisasterOrdered(this.disasterResult);
           
      },*/
      
    }
  }
</script>
<style>
  /*.sub-table{
    border: 1px solid red;
  }
  .sub-table, 
  .sub-table > .v-data-table > .v-data-table__wrapper > table {
    background-color: white;
  }*/
</style>
